'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

import {Socket} from 'phoenix'
import 'angular'
import 'angular-ui-bootstrap'

var editor = function editor() {
	angular.module('editor').controller('EditorController', [
		'$scope',
		'$timeout',
		'$location',
		'Notification',
		function (
			$scope,
			$timeout,
			$location,
			notification
		) {

		var game_id;
		if ($location.search() && $location.search().game_id)
			game_id = $location.search().game_id;
		else {
			game_id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				var r = Math.random() * 16 | 0,
				    v = c == 'x' ? r : r & 0x3 | 0x8;
				return v.toString(16);
			});
			$location.search('game_id', game_id);
		}

		var self = this;
		$scope.rows = [[], [], [], [], [], [], [], [], [], [], [], []];

		function get_tile(x, y) {
			return $scope.rows[y][x];
		}

		$scope.board_name = '';
		if ($location.search() && $location.search().modify)
			$scope.board_name = $location.search().modify;

		$scope.game_type = 'race';

		$scope.creator = '';

		$scope.password = '';

		$scope.getTileId = function (tile) {
			return '' + tile.x + tile.y;
		};

		$scope.game_types = ['race', 'soccer'];

		$scope.floorTiles = [
			'floor',
			'gear_clockwise',
			'gear_counter_clockwise',
			'repair',
			'option',
			'conveyor_counter_clockwise',
			'conveyor_t',
			'conveyor_y_counter_clockwise',
			'conveyor_clockwise',
			'conveyor_y_clockwise',
			'conveyor',
			'express_conveyor_counter_clockwise',
			'express_conveyor_t',
			'express_conveyor_y_counter_clockwise',
			'express_conveyor_clockwise',
			'express_conveyor_y_clockwise',
			'express_conveyor',
			'void',
			'void_start',
			'void_corridor',
			'void_corner',
			'void_side',
			'void_cross'];

		self.rotatableFloorTiles = [
			'conveyor_counter_clockwise',
			'conveyor_t',
			'conveyor_y_counter_clockwise',
			'conveyor_clockwise',
			'conveyor_y_clockwise',
			'conveyor',
			'express_conveyor_counter_clockwise',
			'express_conveyor_t',
			'express_conveyor_y_counter_clockwise',
			'express_conveyor_clockwise',
			'express_conveyor_y_clockwise',
			'express_conveyor',
			'void_start',
			'void_corridor',
			'void_corner',
			'void_side',
			'void_cross'];

		$scope.edgeTiles = ['<none>', 'laser', 'double_laser', 'triple_laser', 'pusher_even', 'pusher_odd', 'pusher_one', 'pusher_two', 'pusher_three', 'wall'];

		self.commonOverlayTiles = [
			'<none>',
			'canner_one_five',
			'canner_two_four',
			'canner_three',
			'startpoint'
		];

		self.raceSpecificOverlayTiles = [
			'checkpoint_one',
			'checkpoint_two',
			'checkpoint_three',
			'checkpoint_four'
		];

		self.raceOverlayTiles = self.commonOverlayTiles.concat(self.raceSpecificOverlayTiles);

		self.soccerSpecificOverlayTiles = [
			'startpoint2',
			'goal',
			'goal2',
			'ball'];

		self.soccerOverlayTiles = self.commonOverlayTiles.concat(self.soccerSpecificOverlayTiles);

		self.overlayTiles = self.commonOverlayTiles.concat(self.raceSpecificOverlayTiles, self.soccerSpecificOverlayTiles);

		$scope.getOverlayTiles = () => $scope.game_type === 'race' ? self.raceOverlayTiles : self.soccerOverlayTiles;

		self.rotateableOverlayTiles = ['startpoint', 'startpoint2']

		$scope.orientations = ['north', 'east', 'south', 'west'];

		$scope.selectedFloorTile = $scope.floorTiles[0];

		for (var i = 0; i < 12; i++) {
			for (var j = 0; j < 12; j++) {
				var tile = {x: j, y: i, tile_elements: [{type: $scope.floorTiles[0], orientation: 'north'}]};
				$scope.rows[i][j] = tile;
				switch (Math.floor(Math.random() * 4)) {
					case 0:
						tile.floorOrientation = 'north';
						break;
					case 1:
						tile.floorOrientation = 'east';
						break;
					case 2:
						tile.floorOrientation = 'south';
						break;
					case 3:
						tile.floorOrientation = 'west';
						break;
				}

				tile.floorNumber = Math.floor(Math.random() * 12) + 1;
			}
		}

		$scope.handle_orientation = function(orientation){
			switch (orientation) {
				case 'east':
					return 'rotate90';
				case 'south':
					return 'rotate180';
				case 'west':
					return 'rotate270';
				default:
					return '';
			}
		};

		function findMatching(tileElements, types, orientation) {
			var result;
			types.some(function (type) {
				result = tileElements.find(function (tileElement) {
					return tileElement.type === type && (!orientation || orientation === tileElement.orientation);
				});
				return result;
			});
			return result;
		}

		function removeExistingTileElements(tileElements, types, orientation) {
			return tileElements.filter(function (tileElement) {
				return !types.some(function (type) {
					return tileElement.type === type && (!orientation || orientation === tileElement.orientation);
				});
			});
		}

		$scope.selectBoardType = function (type){
			self.channel.push("update_board_type", {type: type})
		}

		$scope.selectedFloorTileOrientation = 'north';

		$scope.selectFloorTileElement = function (type) {
			sendUpdatedTile();
		}

		$scope.selectFloorTileOrientation = function (type) {
			sendUpdatedTile();
		}

		$scope.selectOverlayTileElement = function (type) {
			if (type === '<none>') {
				$scope.selectedTile.tile_elements = removeExistingTileElements($scope.selectedTile.tile_elements, self.overlayTiles);
				$scope.selectedOverlayTile = undefined;
				sendUpdatedTile();
				return;
			}

			if(!$scope.selectedOverlayTile.orientation){
				$scope.selectedOverlayTile.orientation = 'north';
				$scope.selectedTile.tile_elements.push($scope.selectedOverlayTile);
			}

			sendUpdatedTile();
		};

		$scope.selectOverlayTileOrientation = function () {
			sendUpdatedTile();
		}

		$scope.selectNorthEdgeTileElement = function (type) {
			if (type === '<none>') {
				$scope.selectedTile.tile_elements = removeExistingTileElements($scope.selectedTile.tile_elements, $scope.edgeTiles, 'north');
				$scope.selectedNorthEdgeTile = undefined;
				sendUpdatedTile();
				return;
			}

			if(!$scope.selectedNorthEdgeTile.orientation){
				$scope.selectedNorthEdgeTile.orientation = 'north';
				$scope.selectedTile.tile_elements.push($scope.selectedNorthEdgeTile);
			}

			sendUpdatedTile();
		};

		$scope.selectEastEdgeTileElement = function (type) {
			if (type === '<none>') {
				$scope.selectedTile.tile_elements = removeExistingTileElements($scope.selectedTile.tile_elements, $scope.edgeTiles, 'east');
				$scope.selectedEastEdgeTile = undefined;
				sendUpdatedTile();
				return;
			}

			if(!$scope.selectedEastEdgeTile.orientation){
				$scope.selectedEastEdgeTile.orientation = 'east';
				$scope.selectedTile.tile_elements.push($scope.selectedEastEdgeTile);
			}

			sendUpdatedTile();
		};

		$scope.selectSouthEdgeTileElement = function (type) {
			if (type === '<none>') {
				$scope.selectedTile.tile_elements = removeExistingTileElements($scope.selectedTile.tile_elements, $scope.edgeTiles, 'south');
				$scope.selectedSouthEdgeTile = undefined;
				sendUpdatedTile();
				return;
			}

			if(!$scope.selectedSouthEdgeTile.orientation){
				$scope.selectedSouthEdgeTile.orientation = 'south';
				$scope.selectedTile.tile_elements.push($scope.selectedSouthEdgeTile);
			}

			sendUpdatedTile();
		};

		$scope.selectWestEdgeTileElement = function (type) {
			if (type === '<none>') {
				$scope.selectedTile.tile_elements = removeExistingTileElements($scope.selectedTile.tile_elements, $scope.edgeTiles, 'west');
				$scope.selectedWestEdgeTile = undefined;
				sendUpdatedTile();
				return;
			}

			if(!$scope.selectedWestEdgeTile.orientation){
				$scope.selectedWestEdgeTile.orientation = 'west';
				$scope.selectedTile.tile_elements.push($scope.selectedWestEdgeTile);
			}

			sendUpdatedTile();
		};

		$scope.selectTile = function (tile) {
			$scope.selectedTile = tile;
			$scope.selectedFloorTile = findMatching(tile.tile_elements, $scope.floorTiles);
			if ($scope.selectedFloorTile) $scope.selectedFloorTileOrientation = $scope.selectedFloorTile.orientation;
			$scope.selectedNorthEdgeTile = findMatching(tile.tile_elements, $scope.edgeTiles, 'north');
			$scope.selectedEastEdgeTile = findMatching(tile.tile_elements, $scope.edgeTiles, 'east');
			$scope.selectedSouthEdgeTile = findMatching(tile.tile_elements, $scope.edgeTiles, 'south');
			$scope.selectedWestEdgeTile = findMatching(tile.tile_elements, $scope.edgeTiles, 'west');
			$scope.selectedOverlayTile = findMatching(tile.tile_elements, self.overlayTiles);
		};

		$scope.canRotateFloorTile = () => $scope.selectedFloorTile && self.rotatableFloorTiles.some((r) => r === $scope.selectedFloorTile.type);

		$scope.canRotateOverlayTile = () => $scope.selectedOverlayTile && self.rotateableOverlayTiles.some((r) => r === $scope.selectedOverlayTile.type);

		self.socket = new Socket('/editorsocket', { params: { token: window.userToken } });
		self.socket.connect();

		var joinParameter = {};
		if ($location.search())
			joinParameter.board_name = $location.search().modify || $location.search().new;

		$location.search('modify', null);
		$location.search('new', null);

		self.channel = self.socket.channel('editor:' + game_id, joinParameter);

		$scope.save_board = function() {
			var valid = true;
			if (!$scope.board_name){
				valid = false;
				notification.error('You have to enter a name for your new board');
			}
			if (!$scope.password) {
				valid = false;
				notification.error('You have to enter a password for your new board');
			}
			if (!$scope.creator) {
				valid = false;
				notification.error('You have to enter a creator alias for your new board');
			}

			if (valid)
				self.channel.push("save_board", {'board_name': $scope.board_name, 'password': $scope.password, 'creator': $scope.creator});
		};

		function sendUpdatedTile() {
			self.channel.push("update_tile", $scope.selectedTile);
		}

		function updateTile(tile) {
			var oldTile = get_tile(tile.x, tile.y);
			tile.floorOrientation = oldTile.floorOrientation;
			tile.floorNumber = oldTile.floorNumber;
			$scope.rows[tile.y][tile.x] = tile;
		}

		self.channel.on('error', function (payload) {
			$scope.$applyAsync(function () {
				notification.error(payload.message);
			});
		});

		self.channel.on('success', function (payload) {
			$scope.$applyAsync(function () {
				notification.success(payload.message);
			});
		})

		self.channel.on('updated_tile', function (tile) {
			$scope.$applyAsync(function () {
				updateTile(tile);
			});
		});

		self.channel.on('updated_tiles', function (payload) {
			$scope.$applyAsync(function () {
				payload.tiles.forEach(updateTile);
			});
		});

		self.channel.on('updated_board_type', (payload) => {
			$scope.$applyAsync(() => {
				$scope.game_type = payload.type;
			});
		});

		self.channel.join()
		.receive('ok', function (resp) {
			console.log('Joined successfully', resp);
			self.channel.push("get_tiles", {});
			self.channel.push("get_board_type", {});
		})
		.receive('error', function (resp) {
			console.log('Unable to join', resp);
		});
	}]);
};

exports.default = editor;
